////////LIBRARY/////////
import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'

/////////STYLED/////////
const ButtonRestStyle = styled.button`
	background: none;
	color: inherit;
	border: none;
	padding: 0;
	font: inherit;
	cursor: pointer;
	outline: inherit;
`
const ImgButtonWrapper = styled(ButtonRestStyle)`
	display: flex;
	justify-content: center;
	align-items: center;
	width: ${(props) => (props.width ? props.width : '32px')};
	height: ${(props) => (props.width ? props.width : '32px')};
	background-color: ${(props) => props.bcg || props.theme.colors.primary};
	box-sizing: border-box;
	border-radius: ${(props) => props.border || '4px'};
	border: none;
	margin: 0 ${(props) => props.margin || 'inherit'};
	${(props) => props.marginRight && `margin-right: ${props.marginRight}px;`}
	${(props) => props.marginLeft && `margin-left: ${props.marginLeft}px;`}
	cursor: pointer;
	font-family: 'Lato', sans-serif;
	:hover {
		background-color: ${(props) => props.hover};
	}
	transition: background-color 0.1s;
`
const ImgButtonWrapperDisabled = styled(ImgButtonWrapper)`
	cursor: not-allowed;
	filter: grayscale(1);
`
const ButtonImg = styled.img`
	max-height: 70%;
	max-width: 70%;
	margin-right: ${(props) => props.margin};
`
/////////STYLED/////////

/**
 *
 * @param color
 * @param img
 * @param action
 * @param margin
 * @param rest
 * @param border
 * @return {*}
 * @constructor
 */
const ImgButton = ({ id, marginLeft, marginRight, color, img, border, action, margin, as, hover, disabled = false, ...rest }) => {
	///////////////////////////////// RENDER ///////////////////////////////////////

	return disabled ? (
		<ImgButtonWrapperDisabled
			bcg={color}
			//onClick={ () => {} }
			margin={margin}
			marginRight={marginRight}
			marginLeft={marginLeft}
			hover={hover}
			as={'div'}
			border={border}
			{...rest}
		>
			<ButtonImg src={img} />
		</ImgButtonWrapperDisabled>
	) : (
		<ImgButtonWrapper
			id={id}
			bcg={color}
			border={border}
			onClick={action}
			margin={margin}
			marginRight={marginRight}
			marginLeft={marginLeft}
			hover={hover}
			as={as}
			{...rest}
		>
			<ButtonImg src={img} />
		</ImgButtonWrapper>
	)
}

ImgButton.propTypes = {
	color: PropTypes.string,
	action: PropTypes.func,
}

ImgButton.defaultPropTypes = {
	color: '',
}

export default ImgButton
